<template>
  <iColumn gap="small" width="fill">
    <iRow
      v-for="(story, idx) in placeholderStories"
      :key="idx"
      gap="small"
      width="fill"
      :style-overrides="{
        paddingTop: 'small',
        paddingBottom: 'small',
        paddingLeft: 'small',
        paddingRight: 'small',
        borderRadius: 'standard',
        backgroundColor: '#f4f5f7',
      }"
    >
      <iColumn gap="extraSmall" width="fill">
        <iText font-weight="strong">
          {{ story.title }}
        </iText>
        <iText variant="subtle" font-size="small">
          {{ story.snippet }}
        </iText>
      </iColumn>
    </iRow>
  </iColumn>
</template>

<script>
// `SmartFeed/components/SmartFeedV2.vue` + `SmartFeed/stores/feed/...`
// live outside the editor directory tree. Studio renders a static
// example feed list inside the canvas preview.
import { DynamicElementMixin } from "%/dynamic-component-editor/mixins/dynamic-element-mixin";
import LayoutWidth from "%/dynamic-component-editor/options/layout-width";
import EmptyStateText from "%/dynamic-component-editor/options/empty-state-text";

export default {
  name: "StoriesUserCommentedOn",
  mixins: [
    DynamicElementMixin,
  ],
  elementPanelSettings: {
    displayName: "Stories User Commented On",
    displayIcon: "hamburger",
    elementGroup: "storiesUserCommentedOnElements",
    elementType: "element",
  },
  options: [
    new LayoutWidth({
      "default": "fill",
      "hover": "fill",
    }, true),
    new EmptyStateText({ "default": "User has not commented on any stories yet." }),
  ],
  computed: {
    placeholderStories() {
      return [
        { title: "A great read about design", snippet: "User commented: This was insightful, thanks!" },
        { title: "Why simplicity wins", snippet: "User commented: Loved the framing here." },
      ];
    },
  },
};
</script>
